import React from 'react'
import { Link } from 'react-router-dom';
import PageTitle from './includes/PageTitle';

export default function NotFound() {
  return (
    <>
    <PageTitle title="Page Not Found - ALMOSTINVISIBLE" />
    <div className='d-flex justify-content-center flex-column align-self-center px-3' style={{position:"fixed", margin: "30vh auto"}}>
       
        <h1 className="unbounded" style={{fontSize:"50px"}}>
           404
        </h1>
        
        <h1 className="unbounded" style={{fontSize:"60px"}}>
           PAGE NOT FOUND...
        </h1>

        <Link to="/products" className="black-button">
          Go Back
        </Link>
    </div>
    
    </>
  )
}
